<div
  class="input-group"
  [ngClass]="inputGroupType === type.InputGroupAppend ? 'append' : ''"
>
  <div
    class="input-group-prepend"
    *ngIf="inputGroupType === type.InputGroupPrepend"
  >
    <ng-container *ngTemplateOutlet="inputGroupTemplate"></ng-container>
  </div>
  <input
    class="form-control shadow-none"
    type="text"
    [name]="name"
    [formControlName]="formControlName"
    placeholder="{{ placeholder | msg | async }}"
  />
  <div
    class="input-group-append"
    *ngIf="inputGroupType === type.InputGroupAppend"
  >
    <ng-container *ngTemplateOutlet="inputGroupTemplate"></ng-container>
  </div>
</div>

<ng-template #inputGroupTemplate>
  <span class="icon-input-group p-2" *ngIf="text && !icon">{{ text }}</span>
  <span class="icon-input-group p-2" *ngIf="icon && !text"
    ><svg-icon [src]="icon"></svg-icon
  ></span>
</ng-template>
